import Pay from "../assets/statics/pay.png";

export const PayWith = () => {
  return (
    <>
      <h4>Payment methods</h4>
      <img src={Pay} alt="" />
    </>
  );
};
